import m from '@bitstillery/mithril'
import {MithrilComponent} from '@bitstillery/mithril'
import {AccessTokens, Tab, TabPanel, Tabs} from '@bitstillery/common/components/portal'
import {$t} from '@bitstillery/common/app'

import {MyPortalPromotions} from './promotions'
import {MyPortalSettings} from './settings'
import {MyPortalEmail} from './email'
import {MyPortalOrders} from '@/components/pages/my_portal/orders/orders'
import {$s} from '@/app'

export class MyPortal extends MithrilComponent {
    override oninit() {
        this.set_tab_context()
    }

    set_tab_context(section?: string) {
        const route = m.route.get()
        // @i18n include: breadcrumbs.my_portal
        // @i18n include: breadcrumbs.profile
        // @i18n include: breadcrumbs.settings
        // @i18n include: breadcrumbs.email
        // @i18n include: breadcrumbs.orders
        // @i18n include: breadcrumbs.promotions
        // @i18n include: breadcrumbs.api_access
        // @i18n include: shell.title.my_portal_api_access
        // @i18n include: shell.description.my_portal_api_access
        if (!section) {
            section = route.startsWith('/my-portal/profile')
                ? 'profile'
                : route.startsWith('/my-portal/settings')
                  ? 'settings'
                  : route.startsWith('/my-portal/email')
                    ? 'email'
                    : route.startsWith('/my-portal/promotions')
                      ? 'promotions'
                      : route.startsWith('/my-portal/api-access')
                        ? 'api_access'
                        : 'settings'
        }
    }

    view() {
        return (
            <Tabs
                className='c-my-portal view'
                header={{
                    onclick: () => {
                        void m.route.set('/my-portal/orders')
                    },
                    title: $t('page.my_portal'),
                }}
                type='nested-view-vertical'
            >
                <Tab
                    icon='myOrders'
                    link='/my-portal/orders'
                    onactivate={() => this.set_tab_context('orders')}
                    route='/my-portal/orders{/*path}'
                    text={$t('my_portal.options.my_orders')}
                >
                    <TabPanel>
                        <MyPortalOrders />
                    </TabPanel>
                </Tab>
                <Tab
                    icon='cog'
                    link='/my-portal/settings'
                    onactivate={() => this.set_tab_context('settings')}
                    // Without API access that tab is gone, and a link or reload landing on it shows the settings.
                    route={
                        $s.identity.user.has_api_access
                            ? '/my-portal/settings{/*path}'
                            : ['/my-portal/settings{/*path}', '/my-portal/api-access']
                    }
                    text={$t('my_portal.options.settings')}
                >
                    <TabPanel>
                        <MyPortalSettings />
                    </TabPanel>
                </Tab>
                <Tab
                    icon='email'
                    link='/my-portal/email'
                    onactivate={() => this.set_tab_context('email')}
                    route='/my-portal/email{/*path}'
                    text={$t('my_portal.email_label')}
                >
                    <TabPanel>
                        <MyPortalEmail />
                    </TabPanel>
                </Tab>
                {$s.identity.user.has_api_access && (
                    <Tab
                        icon='security'
                        id='api-access'
                        link='/my-portal/api-access'
                        onactivate={() => this.set_tab_context('api_access')}
                        route='/my-portal/api-access'
                        text={$t('my_portal.api_access')}
                    >
                        <TabPanel>
                            <AccessTokens can_create={true} endpoint='portal/user/access-tokens' />
                        </TabPanel>
                    </Tab>
                )}
                {$s.promotion.active_grace && (
                    <Tab
                        icon='promotion'
                        id='promotions'
                        link='/my-portal/promotions'
                        onactivate={() => this.set_tab_context('promotions')}
                        route='/my-portal/promotions{/*path}'
                        text={$t('my_portal.promotions')}
                    >
                        <TabPanel>
                            <MyPortalPromotions />
                        </TabPanel>
                    </Tab>
                )}
            </Tabs>
        )
    }
}
